module.exports = __webpack_public_path__ + "static/media/image3.7e69fd37.png";